import { all, put, call, takeLatest } from '@redux-saga/core/effects';
import { string } from 'prop-types';
import { rejectErrorCodeHelper } from '../../util/helpers/registerRejectErrorCodeHelper';

import {
  createMetalStreamBankAccountSuccess,
  createMetalStreamBankAccountError,
  createMetalStreamAmountSuccess,
  createMetalStreamAmountError,
  createMetalStreamAllocationSuccess,
  createMetalStreamAllocationError,
  updateMetalStreamAllocationSuccess,
  updateMetalStreamAllocationError,
  getMetalStreamProductsSuccess,
  getMetalStreamProductsError,
  getMetalStreamGoldProductsSuccess,
  getMetalStreamGoldProductsError,
  getMetalStreamSilverProductsSuccess,
  getMetalStreamSilverProductsError,
  createMetalStreamProductsSuccess,
  createMetalStreamProductsError,
  updateMetalStreamProductsSuccess,
  updateMetalStreamProductsError,
  updateMetalStreamAmountSuccess,
  updateMetalStreamAmountError,
  createMetalStreamBankApplicationFundingSuccess,
  createMetalStreamBankApplicationFundingError,
  updateMetalStreamBankApplicationFundingError,
  updateMetalStreamBankApplicationFundingSuccess,
} from '../actions/metalStream/metalStreamActions';
import {
  CREATE_METAL_STREAM_BANK_ACCOUNT,
  CREATE_METAL_STREAM_AMOUNT,
  CREATE_METAL_STREAM_ALLOCATION,
  UPDATE_METAL_STREAM_ALLOCATION,
  GET_METAL_STREAM_PRODUCTS,
  GET_METAL_STREAM_GOLD_PRODUCTS,
  GET_METAL_STREAM_SILVER_PRODUCTS,
  CREATE_METAL_STREAM_PRODUCTS,
  UPDATE_METAL_STREAM_PRODUCTS,
  UPDATE_METAL_STREAM_AMOUNT,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
} from '../actions/metalStream/metalStreamActionConstants';
import {
  createMetalStreamBankAccountRequest,
  createMetalStreamAllocationsRequest,
  updateMetalStreamAllocationsRequest,
  getMetalStreamProductsRequest,
  updateMetalStreamProductsRequest,
  createMetalStreamProductsRequest,
  updateMetalStreamAmountRequest,
  createMetalStreamAmountRequest,
  createMetalStreamBankApplicationFundingRequest,
  updateMetalStreamBankApplicationFundingRequest,
} from '../../request/metalStreamRequests';

function* createMetalStreamBankAccount({ payload }) {
  try {
    const { data } = yield call(createMetalStreamBankAccountRequest, payload);
    yield put(createMetalStreamBankAccountSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createMetalStreamBankAccountError(errorMessage));
    yield call(payload.onError, {
      type: string,
      message: errorMessage,
    });
  }
}

function* createMetalStreamAmount({ payload }) {
  try {
    const { data } = yield call(createMetalStreamAmountRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    yield put(createMetalStreamAmountSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createMetalStreamAmountError(errorMessage));
  }
}

function* updateMetalStreamAmount({ payload }) {
  try {
    const { data } = yield call(updateMetalStreamAmountRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    yield put(updateMetalStreamAmountSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updateMetalStreamAmountError(errorMessage));
  }
}

function* createMetalStreamAllocation({ payload }) {
  try {
    const { data } = yield call(createMetalStreamAllocationsRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    yield put(createMetalStreamAllocationSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createMetalStreamAllocationError(errorMessage));
  }
}

function* updateMetalStreamAllocation({ payload }) {
  try {
    const { data } = yield call(updateMetalStreamAllocationsRequest, payload);
    yield put(updateMetalStreamAllocationSuccess(data));
    yield call(payload.onSuccess);
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updateMetalStreamAllocationError(errorMessage));
    yield call(payload.onError, {
      type: string,
      message: errorMessage,
    });
  }
}

function* getMetalStreamProducts({ payload }) {
  try {
    const { data } = yield call(getMetalStreamProductsRequest, {
      ApplicationUid: payload.ApplicationUid,
      metalType: payload.metalType,
    });
    yield put(getMetalStreamProductsSuccess(data));
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(getMetalStreamProductsError(errorMessage));
  }
}

function* getMetalStreamGoldProducts({ payload }) {
  try {
    const { data } = yield call(getMetalStreamProductsRequest, {
      ApplicationUid: payload.ApplicationUid,
      metalType: 'Gold',
    });
    yield put(getMetalStreamGoldProductsSuccess(data));
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(getMetalStreamGoldProductsError(errorMessage));
  }
}

function* getMetalStreamSilverProducts({ payload }) {
  try {
    const { data } = yield call(getMetalStreamProductsRequest, {
      ApplicationUid: payload.ApplicationUid,
      metalType: 'Silver',
    });
    yield put(getMetalStreamSilverProductsSuccess(data));
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(getMetalStreamSilverProductsError(errorMessage));
  }
}

function* createMetalStreamProducts({ payload }) {
  try {
    yield call(createMetalStreamProductsRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });

    yield put(createMetalStreamProductsSuccess(payload.data));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(createMetalStreamProductsError(errorMessage));
  }
}

function* updateMetalStreamProducts({ payload }) {
  try {
    const { data } = yield call(updateMetalStreamProductsRequest, payload);
    yield put(updateMetalStreamProductsSuccess(data));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = rejectErrorCodeHelper(error);
    yield put(updateMetalStreamProductsError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: string,
        message: errorMessage,
      });
    }
  }
}

function* createMetalStreamBankApplicationFunding({ payload }) {
  try {
    const data = yield call(createMetalStreamBankApplicationFundingRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(createMetalStreamBankApplicationFundingSuccess(data));
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createMetalStreamBankApplicationFundingError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateMetalStreamBankApplicationFunding({ payload }) {
  try {
    const data = yield call(updateMetalStreamBankApplicationFundingRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    if (data) {
      yield put(updateMetalStreamBankApplicationFundingSuccess(data));
      yield call(payload.onSuccess, data);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateMetalStreamBankApplicationFundingError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

export default function* metalStreamSaga() {
  return yield all([
    takeLatest(CREATE_METAL_STREAM_BANK_ACCOUNT, createMetalStreamBankAccount),
    takeLatest(CREATE_METAL_STREAM_AMOUNT, createMetalStreamAmount),
    takeLatest(UPDATE_METAL_STREAM_AMOUNT, updateMetalStreamAmount),
    takeLatest(CREATE_METAL_STREAM_ALLOCATION, createMetalStreamAllocation),
    takeLatest(UPDATE_METAL_STREAM_ALLOCATION, updateMetalStreamAllocation),
    takeLatest(GET_METAL_STREAM_PRODUCTS, getMetalStreamProducts),
    takeLatest(GET_METAL_STREAM_GOLD_PRODUCTS, getMetalStreamGoldProducts),
    takeLatest(GET_METAL_STREAM_SILVER_PRODUCTS, getMetalStreamSilverProducts),
    takeLatest(CREATE_METAL_STREAM_PRODUCTS, createMetalStreamProducts),
    takeLatest(UPDATE_METAL_STREAM_PRODUCTS, updateMetalStreamProducts),
    takeLatest(
      CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
      createMetalStreamBankApplicationFunding,
    ),
    takeLatest(
      UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING,
      updateMetalStreamBankApplicationFunding,
    ),
  ]);
}
